module.exports = __webpack_public_path__ + "media/images/logo_normas-a1b78a62bc56feac639efc320994bdb3.png";